import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
declare var ga: any;

@Component({
  selector: 'app-forgot-password-section',
  templateUrl: './forgot-password-section.component.html',
  styleUrls: ['./forgot-password-section.component.scss'],
  providers: [ErrorHandler]
})
export class ForgotPasswordSectionComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/forgot-password');
      ga('send', 'pageview');
    }
  }

}
